<template>
  <b-modal class="modal modal-confirm bg-body" id="ModalFormObat" size="xl">
    <template #modal-title>
      <h4 class="mb-0 text-left">Ubah Tagihan Obat dan Alkes</h4>
    </template>
    <div class="container-fluid">
      <Alert
        v-if="saveFailed"
        :alert="{
          type: 'danger',
          title: 'Gagal Menyimpan Data',
          content:
            'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
        }"
      />
      <Alert
        v-if="saveSuccess"
        :alert="{
          type: 'success',
          title: 'Berhasil Menyimpan Data',
          content: 'Penyimpanan data berhasil dilakukan',
        }"
      />
      <!-- <PageContentHeader
        :data="data"
        :fromUrl="fromUrl || ''"
        :fromTab="$route.query.fromTab || ''"
      />
      <DetailTop v-if="detailTop" :detailTop="detailTop" />
      <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
        <div class="col-md-7 pr-1" v-if="detailLeftTop">
          <DetailLeft :detailLeftTop="detailLeftTop" />
        </div>
        <div class="col-md-5 pl-1" v-if="detailRightTop">
          <DetailRight :detailRightTop="detailRightTop" />
        </div>
      </div> -->
      <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
      <div style="position: relative">
        <div class="d-flex flex-between my-3">
          <h5 class="mb-2">Resep Obat / Alkes</h5>
        </div>
        <div class="form-group">
          <div class="input-group">
            <input
              type="text"
              :class="
                'form-control form-control-lg pl-5 with-icon-left without-label ' +
                  (isError ? 'error' : '')
              "
              placeholder="Cari kode atau nama obat di sini"
              @input="
                (e) => {
                  a_obat = false;
                  s_obat = e.target.value;
                  updateForm();
                }
              "
              :value="s_obat"
              v-on:keyup.enter="() => search('obat')"
            />
            <i class="material-symbols-outlined" style="margin-top: -0.25rem"
              >search</i
            >
            <div class="input-group-append">
              <button
                class="btn btn-secondary btn-with-icon-left"
                @click="() => search('obat')"
              >
                <i class="material-symbols-outlined">search</i>
                CARI
              </button>
            </div>
          </div>
        </div>
        <SearchResult
          type=""
          @addItem="(item) => addItem(item, 'obat')"
          v-if="s_obat && a_obat"
          :loading="l_obat"
          :data="r_obat"
        />
        <table v-if="obat.length" class="responsive">
          <thead>
            <th>KODE</th>
            <th>NAMA BARANG</th>
            <th>JENIS OBAT</th>
            <th>LOKASI</th>
            <th>HARGA/PC</th>
            <th>JUMLAH</th>
            <th>EMBALASE</th>
            <th>TUSLAH</th>
            <th>SUB TOTAL</th>
            <th></th>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in obat"
              v-bind:key="item.id + Math.random(1024)"
              v-show="!item.deleted"
            >
              <td>{{ item.kode }}</td>
              <td>{{ item.nama }}</td>
              <td>{{ item.jenis }}</td>
              <td>{{ item.lokasi }}</td>
              <td>{{ item.formatted_harga }}</td>
              <td>
                <InputNumber
                  @handleChange="(e) => handleChange(e)"
                  :value="item.jumlah"
                  :input="{ class: 'inline', name: 'jumlah-' + index }"
                />
              </td>
              <td>
                <InputMoney
                  @handleChange="(e) => handleChange(e)"
                  :value="item.embalase"
                  :input="{
                    class: 'group-inline',
                    name: 'embalase-' + index,
                  }"
                />
              </td>
              <td>
                <InputMoney
                  @handleChange="(e) => handleChange(e)"
                  :value="item.tuslah"
                  :input="{
                    class: 'group-inline',
                    name: 'tuslah-' + index,
                  }"
                />
              </td>
              <td>{{ convertToRupiah(item.sub_total) }}</td>
              <td>
                <button
                  class="btn btn-icon btn-danger btn-sm"
                  @click="() => deleteItem('obat', item.id)"
                >
                  <i class="material-symbols-outlined">delete</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--/form-->
    </div>
    <template #modal-footer>
      <div class="w-100">
        <button
          class="btn btn-primary float-right"
          @click="
            () => {
              handleForm();
            }
          "
        >
          SIMPAN
        </button>
        <button
          type="button"
          class="btn btn-outline-primary mr-3 float-right"
          @click="$bvModal.hide('ModalFormObat')"
        >
          BATAL
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
import SearchResult from "@/components/SearchResult.vue";
// import Navbar from "@/components/Navbar.vue";
// import Sidebar from "@/components/Sidebar.vue";
// import PageContentHeader from "@/components/PageContentHeader.vue";
// // import FormRow from '@/components/FormRow.vue'
// import DetailTop from "@/components/DetailTop.vue";
// import DetailLeft from "@/components/DetailLeft.vue";
// import DetailRight from "@/components/DetailRight.vue";
import InputMoney from "@/components/InputMoney.vue";
import InputNumber from "@/components/InputNumber.vue";
import {
  setPatientIntro,
  setRawatIntro,
  convertToRupiah,
} from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import { data } from "@/data/ApotikDetail.js";
export default {
  name: "ModalFormObat",
  components: {
    // Navbar,
    // Sidebar,
    // PageContentHeader,
    // DetailTop,
    // DetailLeft,
    // DetailRight,
    InputMoney,
    InputNumber,
    Alert,
    SearchResult,
  },
  props: {
    no_rawat: String,
    id_ralan: Number,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      saveSuccess: false,
      saveFailed: false,
      formSet: {
        no_rawat: "",
      },
      n: 0,
      s_obat: "",
      r_obat: [],
      obat: [],
      a_obat: false,
      l_obat: false,
      isError: false,
      jumlah: [],
      embalase: [],
      tuslah: [],
      convertToRupiah: convertToRupiah,
    };
  },
  methods: {
    showModal() {
      this.$bvModal.show("ModalFormObat");
    },
    hideModal() {
      this.$bvModal.hide("ModalFormObat");
    },
    // handleForm() {
    //   this.$emit("onSave");
    //   this.hideModal();
    // },
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    handleForm: async function() {
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        self.n = this.obat.filter(
          (item) => !(item.deleted && !item.id_ralan_obat)
        ).length;
        let obats =
          this.obat && this.obat.length
            ? this.obat
                .filter((item) => !(item.deleted && !item.id_ralan_obat))
                .map((item) => {
                  return {
                    operation: item.deleted ? "delete" : null,
                    no_rawat: self["no_rawat"],
                    id_obat: item.id,
                    embalase: item.embalase,
                    tuslah: item.tuslah,
                    jumlah: item.jumlah,
                  };
                })
            : [];
        //console.log(obats);
        if (obats && obats.length) {
          try {
            let result = await this.$store.state.HTTP_JSON.post(
              `ralan/resep/obat-bulk`,
              { obats }
            );
            //console.log(result);
            if (!result || result.status != 200) {
              this.saveFailed = true;
              this.saveSuccess = false;
              this.checkSuccess();
              return;
            }
          } catch (e) {
            //console.log(e);
            this.saveFailed = true;
            this.saveSuccess = false;
            this.checkSuccess();
            return;
          }
        }
        this.checkSuccess();
      } else {
        this.saveFailed = true;
        this.saveSuccess = false;
        this.checkSuccess();
      }
    },
    handleFormOld: async function() {
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        self.n = this.obat.filter(
          (item) => !(item.deleted && !item.id_ralan_obat)
        ).length;

        this.obat.forEach(async function(item) {
          //n-=1;
          if (!item.deleted) {
            let body = `no_rawat=${self["no_rawat"]}&id_obat=${item.id}&harga=${item.harga}&jumlah=${item.jumlah}&embalase=${item.embalase}&tuslah=${item.tuslah}&sub_total=${item.sub_total}`;
            if (!item.id_ralan_obat) {
              await self.saveData(body);
            } else {
              await self.saveData(body, item.id_ralan_obat);
            }
          } else {
            if (item.id_ralan_obat) {
              await self.deleteData(item.id_ralan_obat);
            }
          }
        });
      } else {
        //console.log(valid);
      }
    },
    async saveData(body, id) {
      try {
        if (id) {
          let result = await this.$store.state.HTTP_ENC.put(
            `ralan/resep/obat/${id}`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        } else {
          let result = await this.$store.state.HTTP_ENC.post(
            `ralan/resep/obat`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        }
      } catch (e) {
        ////console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    async deleteData(id) {
      try {
        let result = await this.$store.state.HTTP_ENC.delete(
          `ralan/resep/obat/${id}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.n = this.n - 1;
          if (this.n == 0) {
            this.checkSuccess();
          }
        }
      } catch (e) {
        ////console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        this.$emit("onSave");
        this.hideModal();
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
        }, 1000);
      }
    },
    handleChange(e) {
      // if (e.target.type == "file") {
      //   if(e.target.files && e.target.files.length) { this.formSet[e.target.name] = e.target.files[0]; }
      // } else {
      //   this.formSet[e.target.name] = e.target.value;
      // }
      let name = e.target.name.split("-")[0];
      let index = e.target.name.split("-")[1];
      this.obat[index][name] = parseInt(e.target.value || 0);
      //console.log(this.obat[index][name]);
      this.obat[index]["sub_total"] =
        this.obat[index].jumlah * this.obat[index].harga +
        this.obat[index].embalase +
        this.obat[index].tuslah;
      this.obat.splice(index, 1, this.obat[index]);
      //console.log(this.obat[index]);
      // this.updateForm();
    },

    updateForm() {
      // this.obatForm[0].columns[0].value=String(this.formSet['id_petugas']);
      // this.obatForm[0].columns[1].value=String(this.formSet['id_dokter']);
      // this.labForm[0].columns[0].value=String(this.formSet['id_petugas_lab']);
      // this.labForm[0].columns[1].value=this.formSet['lab_type'];
    },
    validateForm: function() {
      let valid = true;
      // let self = this;

      return valid;
    },
    fetchData: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/resep/obat?per_page=9999999999&no_rawat=${this["no_rawat"]}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_ralan_obat = item.id;
            item.id = item.obat.id;
            item.kode = item.obat.kode;
            item.nama = item.obat.nama;
            item.jenis = item.obat.jenis;
            item.lokasi = item.obat.lokasi;
            self.obat.push(item);
          });
          self.obat = self.obat.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
          // if(result.data.length){
          //   self.formSet.id_petugas_lab=String(result.data[0].id_petugas);
          //   labForm[0].columns[0].value=self.formSet.id_petugas_lab;
          //   self.formSet.lab_type=result.data[0].kategori;
          //   labForm[0].columns[1].value=self.formSet.lab_type;
          // }
          //console.log(self['formSet']);
        }
      } catch (e) {
        //console.log(e);
      }
    },
    search: async function(type) {
      //console.log(type);
      this["a_" + type] = true;
      this["l_" + type] = true;

      let url;
      if (type == "lab") {
        url = "periksalab";
      } else {
        url = "obat";
      }
      try {
        let result = await this.$store.state.HTTP.get(
          `${url}?per_page=9999999999&q=${this["s_" + type]}`
        );
        //console.log(result);
        if (result.status == "200") {
          // this['r_'+type]=result.data;
          let self = this;
          this["r_" + type] = result.data.map(function(item) {
            item.formatted_harga = self.convertToRupiah(item.harga);
            return item;
          });
          //console.log(this['r_'+type]);
          self["l_" + type] = false;
        } else {
          this["r_" + type] = [];
          self["l_" + type] = false;
        }
      } catch (e) {
        this["r_" + type] = [];
        this["l_" + type] = false;
      }
    },
    addItem: async function(item, type) {
      if (!this[type].find((el) => el.id == item.id)) {
        item.jumlah = 1;
        item.embalase = 0;
        item.tuslah = 0;
        item.sub_total = item.harga;
        this[type].push(item);
      }
      this["r_" + type] = [];
      this["s_" + type] = "";
      this["a_" + type] = false;
      //console.log(this[type]);
    },
    deleteItem: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
        }
        return item;
      });
      //console.log(this[type]);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    try {
      // let result = await this.$store.state.HTTP.get(`ralan/tebus/obat/${this.id_ralan}`);
      let result = await this.$store.state.HTTP.get(`ralan/${this.id_ralan}`);
      //console.log(result);
      if (result.status == "200") {
        //console.log('ralan');
        //console.log(result.data);
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        //console.log('ralan');
        this["no_rawat"] = result.data.no_rawat;
        //console.log(this.formSet['no_rawat']);
      } else {
        //   this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    this.fetchData();
  },
};
</script>
